import React from 'react'
import { ConfigurationContext, useToggleState } from '@news-mono/web-common'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'
import { NewsTipsForm as SevenNewsV2NewsTipsForm } from '../../../SevenNewsV2/NewsTipsForm/NewsTipsForm'
import { RecaptchaProvider } from '../../../recaptcha/Recaptcha'

export const NewsTipsFormWrapper: React.FC = () => {
    const config = React.useContext(ConfigurationContext)
    const toggles = useToggleState()

    if (
        !config ||
        !isFeatureEnabled(toFeatureState(toggles), 'news-tips-form') ||
        !config.recaptureSiteKey
    ) {
        return null
    }

    return (
        <RecaptchaProvider siteKey={config.recaptureSiteKey}>
            <SevenNewsV2NewsTipsForm />
        </RecaptchaProvider>
    )
}
